function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  opacity: 0.8,
  width: 32,
  height: 32,
  rx: 16,
  fill: "#DADCDD"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#facebook_grey_svg__clip0)"
}, React.createElement("path", {
  d: "M19.07 13.585a.25.25 0 00-.185-.085H17v-.705c0-.14.03-.3.255-.3h1.5a.22.22 0 00.175-.075.25.25 0 00.07-.17v-2a.25.25 0 00-.25-.25h-2.165C14.185 10 14 12.05 14 12.675v.825h-1.25a.25.25 0 00-.25.25v2c0 .138.112.25.25.25H14v5.75c0 .138.112.25.25.25h2.5a.25.25 0 00.25-.25V16h1.675a.25.25 0 00.25-.225l.21-2a.249.249 0 00-.065-.19z",
  fill: "#192228"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "facebook_grey_svg__clip0"
}, React.createElement("path", {
  fill: "#fff",
  d: "M10 10h12v12H10z"
})));

function SvgFacebookGrey(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgFacebookGrey;